export class JobListQuery {
    constructor(public Type?, public Period?, public FromDate?, public ToDate?, public ScID?, public DID?) { }
}